import { NgModule } from "@angular/core";
import { RepositoryFactoryProvider } from "../../../common/utils/backend.provider";
import { LocalStorageRepositoryInterface } from "../local-storage/local-storage.interface";
import { LoadingOverlayService } from "../../components/loading-overlay/services/loading-overlay.service";
import { RouterService } from "../../services/router.service";
import { TokenService } from "../../services/user/token.service";
import { UsersHttpBackend } from "../users/users.backend";
import { StatusesRepositoryInterface } from "./statuses.interface";
import { StatusesRepository } from "./statuses.repository";

@NgModule({
  providers: [
    RepositoryFactoryProvider({
      provide: StatusesRepositoryInterface,
      repository: StatusesRepository,
      backend: UsersHttpBackend,
      deps: [
        LocalStorageRepositoryInterface,
        RouterService,
        LoadingOverlayService,
        TokenService
      ]
    })
  ]
})
export class StatusesRepositoryModule { }